"use client";
import { c as y, g as Cr } from "./_commonjsHelpers-CXJ7dpIk.mjs";
var m, nr;
function Ir() {
  if (nr) return m;
  nr = 1;
  var r = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function e(a) {
    return a.match(r) || [];
  }
  return m = e, m;
}
var A, tr;
function Hr() {
  if (tr) return A;
  tr = 1;
  var r = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function e(a) {
    return r.test(a);
  }
  return A = e, A;
}
var x, or;
function Vr() {
  if (or) return x;
  or = 1;
  var r = typeof y == "object" && y && y.Object === Object && y;
  return x = r, x;
}
var j, ur;
function Jr() {
  if (ur) return j;
  ur = 1;
  var r = Vr(), e = typeof self == "object" && self && self.Object === Object && self, a = r || e || Function("return this")();
  return j = a, j;
}
var O, sr;
function $() {
  if (sr) return O;
  sr = 1;
  var r = Jr(), e = r.Symbol;
  return O = e, O;
}
var C, fr;
function Nr() {
  if (fr) return C;
  fr = 1;
  function r(e, a) {
    for (var n = -1, i = e == null ? 0 : e.length, t = Array(i); ++n < i; )
      t[n] = a(e[n], n, e);
    return t;
  }
  return C = r, C;
}
var U, cr;
function Br() {
  if (cr) return U;
  cr = 1;
  var r = Array.isArray;
  return U = r, U;
}
var W, dr;
function $r() {
  if (dr) return W;
  dr = 1;
  var r = $(), e = Object.prototype, a = e.hasOwnProperty, n = e.toString, i = r ? r.toStringTag : void 0;
  function t(o) {
    var u = a.call(o, i), s = o[i];
    try {
      o[i] = void 0;
      var f = !0;
    } catch {
    }
    var c = n.call(o);
    return f && (u ? o[i] = s : delete o[i]), c;
  }
  return W = t, W;
}
var w, br;
function Kr() {
  if (br) return w;
  br = 1;
  var r = Object.prototype, e = r.toString;
  function a(n) {
    return e.call(n);
  }
  return w = a, w;
}
var M, gr;
function Qr() {
  if (gr) return M;
  gr = 1;
  var r = $(), e = $r(), a = Kr(), n = "[object Null]", i = "[object Undefined]", t = r ? r.toStringTag : void 0;
  function o(u) {
    return u == null ? u === void 0 ? i : n : t && t in Object(u) ? e(u) : a(u);
  }
  return M = o, M;
}
var z, lr;
function Xr() {
  if (lr) return z;
  lr = 1;
  function r(e) {
    return e != null && typeof e == "object";
  }
  return z = r, z;
}
var F, vr;
function Yr() {
  if (vr) return F;
  vr = 1;
  var r = Qr(), e = Xr(), a = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || e(i) && r(i) == a;
  }
  return F = n, F;
}
var k, Sr;
function re() {
  if (Sr) return k;
  Sr = 1;
  var r = $(), e = Nr(), a = Br(), n = Yr(), i = r ? r.prototype : void 0, t = i ? i.toString : void 0;
  function o(u) {
    if (typeof u == "string")
      return u;
    if (a(u))
      return e(u, o) + "";
    if (n(u))
      return t ? t.call(u) : "";
    var s = u + "";
    return s == "0" && 1 / u == -1 / 0 ? "-0" : s;
  }
  return k = o, k;
}
var L, pr;
function K() {
  if (pr) return L;
  pr = 1;
  var r = re();
  function e(a) {
    return a == null ? "" : r(a);
  }
  return L = e, L;
}
var G, Rr;
function ee() {
  if (Rr) return G;
  Rr = 1;
  var r = "\\ud800-\\udfff", e = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = e + a + n, t = "\\u2700-\\u27bf", o = "a-z\\xdf-\\xf6\\xf8-\\xff", u = "\\xac\\xb1\\xd7\\xf7", s = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", f = "\\u2000-\\u206f", c = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", d = "A-Z\\xc0-\\xd6\\xd8-\\xde", v = "\\ufe0e\\ufe0f", S = u + s + f + c, g = "['’]", l = "[" + S + "]", h = "[" + i + "]", p = "\\d+", q = "[" + t + "]", R = "[" + o + "]", _ = "[^" + r + S + p + t + o + d + "]", T = "\\ud83c[\\udffb-\\udfff]", Wr = "(?:" + h + "|" + T + ")", wr = "[^" + r + "]", Q = "(?:\\ud83c[\\udde6-\\uddff]){2}", X = "[\\ud800-\\udbff][\\udc00-\\udfff]", b = "[" + d + "]", Mr = "\\u200d", Y = "(?:" + R + "|" + _ + ")", zr = "(?:" + b + "|" + _ + ")", rr = "(?:" + g + "(?:d|ll|m|re|s|t|ve))?", er = "(?:" + g + "(?:D|LL|M|RE|S|T|VE))?", ar = Wr + "?", ir = "[" + v + "]?", Fr = "(?:" + Mr + "(?:" + [wr, Q, X].join("|") + ")" + ir + ar + ")*", kr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Lr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Gr = ir + ar + Fr, Zr = "(?:" + [q, Q, X].join("|") + ")" + Gr, Er = RegExp([
    b + "?" + R + "+" + rr + "(?=" + [l, b, "$"].join("|") + ")",
    zr + "+" + er + "(?=" + [l, b + Y, "$"].join("|") + ")",
    b + "?" + Y + "+" + rr,
    b + "+" + er,
    Lr,
    kr,
    p,
    Zr
  ].join("|"), "g");
  function Pr(Dr) {
    return Dr.match(Er) || [];
  }
  return G = Pr, G;
}
var Z, _r;
function ae() {
  if (_r) return Z;
  _r = 1;
  var r = Ir(), e = Hr(), a = K(), n = ee();
  function i(t, o, u) {
    return t = a(t), o = u ? void 0 : o, o === void 0 ? e(t) ? n(t) : r(t) : t.match(o) || [];
  }
  return Z = i, Z;
}
var ie = ae();
const le = /* @__PURE__ */ Cr(ie);
var E, yr;
function ne() {
  if (yr) return E;
  yr = 1;
  function r(e, a, n) {
    var i = -1, t = e.length;
    a < 0 && (a = -a > t ? 0 : t + a), n = n > t ? t : n, n < 0 && (n += t), t = a > n ? 0 : n - a >>> 0, a >>>= 0;
    for (var o = Array(t); ++i < t; )
      o[i] = e[i + a];
    return o;
  }
  return E = r, E;
}
var P, hr;
function te() {
  if (hr) return P;
  hr = 1;
  var r = ne();
  function e(a, n, i) {
    var t = a.length;
    return i = i === void 0 ? t : i, !n && i >= t ? a : r(a, n, i);
  }
  return P = e, P;
}
var D, qr;
function Ur() {
  if (qr) return D;
  qr = 1;
  var r = "\\ud800-\\udfff", e = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = e + a + n, t = "\\ufe0e\\ufe0f", o = "\\u200d", u = RegExp("[" + o + r + i + t + "]");
  function s(f) {
    return u.test(f);
  }
  return D = s, D;
}
var I, Tr;
function oe() {
  if (Tr) return I;
  Tr = 1;
  function r(e) {
    return e.split("");
  }
  return I = r, I;
}
var H, mr;
function ue() {
  if (mr) return H;
  mr = 1;
  var r = "\\ud800-\\udfff", e = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = e + a + n, t = "\\ufe0e\\ufe0f", o = "[" + r + "]", u = "[" + i + "]", s = "\\ud83c[\\udffb-\\udfff]", f = "(?:" + u + "|" + s + ")", c = "[^" + r + "]", d = "(?:\\ud83c[\\udde6-\\uddff]){2}", v = "[\\ud800-\\udbff][\\udc00-\\udfff]", S = "\\u200d", g = f + "?", l = "[" + t + "]?", h = "(?:" + S + "(?:" + [c, d, v].join("|") + ")" + l + g + ")*", p = l + g + h, q = "(?:" + [c + u + "?", u, d, v, o].join("|") + ")", R = RegExp(s + "(?=" + s + ")|" + q + p, "g");
  function _(T) {
    return T.match(R) || [];
  }
  return H = _, H;
}
var V, Ar;
function se() {
  if (Ar) return V;
  Ar = 1;
  var r = oe(), e = Ur(), a = ue();
  function n(i) {
    return e(i) ? a(i) : r(i);
  }
  return V = n, V;
}
var J, xr;
function fe() {
  if (xr) return J;
  xr = 1;
  var r = te(), e = Ur(), a = se(), n = K();
  function i(t) {
    return function(o) {
      o = n(o);
      var u = e(o) ? a(o) : void 0, s = u ? u[0] : o.charAt(0), f = u ? r(u, 1).join("") : o.slice(1);
      return s[t]() + f;
    };
  }
  return J = i, J;
}
var N, jr;
function ce() {
  if (jr) return N;
  jr = 1;
  var r = fe(), e = r("toUpperCase");
  return N = e, N;
}
var B, Or;
function de() {
  if (Or) return B;
  Or = 1;
  var r = K(), e = ce();
  function a(n) {
    return e(r(n).toLowerCase());
  }
  return B = a, B;
}
var be = de();
const ve = /* @__PURE__ */ Cr(be);
export {
  ve as c,
  le as w
};
